"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m0 9c2.4 0 6-.167 6-2.1S16.2 13 12 13s-6 2.967-6 4.9S9.6 20 12 20"
}), 'UserFilled');
//# sourceMappingURL=index.js.map